import React from 'react'
import './result-hero-section.scss';
import AppCTA from '../../../../common/features/cta';
import AppImage from '../../../../common/features/image';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../../../common/context';
import { getInsightTabPath } from '../../../../common/utils';

function ResultHero(props) {
  const navigation = useNavigate();
  const { data } = props;
  const {insightTab} = useAppContext();
  const insightPath = getInsightTabPath(insightTab);
  const NAV_URL ='/' + insightPath + data.slug;
  //  insightTab !== 'whats'?'/' + insightPath + data.slug:data.slug;
  console.log("NAV_URL",NAV_URL);
  
  const clickHandler = () => {
    const navLink = '/' + insightPath + data.slug;
    // insightTab !== 'whats'?'/' + insightPath + data.slug:data.slug;
    navigation(navLink);
  }
  const cardBanner = data.banner ? data.banner : '/images/insights/insight-hero.png';
  return (
    <div className='result-hero-container'>
      <div className='result-hero-div'>
        <div className='result-hero-wrap'>
        <div className="img-container col-lg-7 col-md-12 col-sm-12" onClick={clickHandler}>
              <AppImage src={cardBanner} className='insight-hero-img' />
          </div>
          
          <div className="text-container col-lg-5 col-md-12 col-sm-12">
            <p className="insight-category">{data.eyebrowText}</p>
            <h2 className="insight-title" onClick={clickHandler}>{data.title || ""}</h2>
           
            <div className="d-none d-md-block insight-cta">
              <AppCTA.WithEnergyPurple title={data.ctaText || ""} url={NAV_URL} />
            </div>
          </div>
        </div>
       
      </div>
    </div>
  )
}
export default ResultHero